<app-navigation>
    <app-einsaetze-table *ngIf="showTableStatus"  (editEntry)="editEntry($event)"></app-einsaetze-table> 
    <app-einsaetze-form *ngIf="showFormStatus" (showTable)="showTable()" [entryId]="formEntryId"></app-einsaetze-form>
</app-navigation>